import React from "react";

let FilterableColumn = ({ options, title, filterName, onApplyFilter }) => {
  let onAddFilter = e => {
    onApplyFilter(filterName, e.target.value);
  };

  return (
    <th>
      <select className="browser-default" onChange={onAddFilter} name={filterName}>
        <option value="">{title}</option>
        {
          options.map((option, i) => (
            <option key={i} value={option}>{option}</option>
          ))
        }
      </select>
    </th>
  )
}

export default FilterableColumn;
